import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable ,  of } from 'rxjs';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError =
  <T> (operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

/** Handles HttpClient errors */
@Injectable()
export class HttpErrorHandlerService {
  constructor() { }

  /** Create curried handleError function that already knows the service name */
  createHandleError = (serviceName = '') => <T>
  (operation = 'operation', result = {} as T) => this.handleError(serviceName, operation, result);

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T> (serviceName = '', operation = 'operation', result = {} as T) {

    return (error: HttpErrorResponse): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      const message = (error.error instanceof ErrorEvent) ?
        error.error.message :
        `server returned code ${error.status} with body "${error.error}"`;

      // TODO: better job of transforming error for user consumption
      console.log(`${serviceName}: ${operation} failed: ${message}`);

      // Let the app keep running by returning a safe result.
      return of( result );
    };

  }

  getErrorMessage(errorSlug) {
    switch (errorSlug) {
      case 'app-is-smsf':
        return 'This application is not eligible for Further Advance or a Linked Loan. Please select new application and proceed through the wizard. Ref: E1';
      case 'app-is-discharged-existing-security':
      case 'app-is-discharged-existing-security-new-security':
        return 'This application is not eligible for Further Advance or a Linked Loan with shared security. Please select "Existing borrower using different security (new linked loan)" and proceed through the wizard. Ref: E2';
      case 'app-is-car-existing-security':
      case 'app-is-car-existing-security-new-security':
        return 'This application is not eligible for Further Advance or a Linked Loan with shared security. Please select "Existing borrower using different security (new linked loan)" and proceed through the wizard. Ref: E3';
      case 'app-is-home-construction-retained-more-than-zero-existing-security':
      case 'app-is-home-construction-retained-more-than-zero-existing-security-new-security':
        return 'This application is not eligible for Further Advance or a Linked Loan with shared security. Please select “Existing borrower using different security (new linked loan)“ and proceed through the wizard. Ref: E4';
      case 'app-is-fa-fa-by-variation-additional-advance-existing-security':
        return 'This application is not eligible for Further Advance. Please select "Existing borrower using different security (new linked loan)" or "Existing borrower using existing and new security (new linked loan)" and proceed through the wizard. Ref: E5';
      case 'out-of-permission':
        return 'This application is not available. Please select new application and proceed through the wizard. Ref: E6';
      default:
        return null;
    }
  }
}